// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__29PKL","productName":"Table_productName__P3pSW"};